module.exports = __webpack_public_path__ + "media/application/images/svgs/command-0c1e5ef10ba7d941c88a6496e0a00511.svg";